import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { DividerRoot } from "./divider.styles.js";
const Divider = forwardRef(
  function Divider2(inProps, ref) {
    return /* @__PURE__ */ jsx(DividerRoot, { ...inProps, ref });
  }
);
export {
  Divider
};
//# sourceMappingURL=divider.component.js.map
